import { useRecoilState } from "recoil";
import { userAuthState } from "../../../../atom";
import { Grid, IconButton, Typography } from "@mui/material";
import { EditOutlined } from "@mui/icons-material";
import { useEffect, useState } from "react";
import {
  convertCentsToDollars,
  convertToKilometers,
} from "../../../../helpers/formatters";
import { useBillingSettings } from "../../../../hooks/useBillingSettings";
import { isCurrentAdminSuperAdmin } from "../../../../helpers/authHelpers";
import Button from "../../../../components/Button/Button";
import PriceChangeIcon from "@mui/icons-material/PriceChange";
import { useOrganizationFavouriteLocations } from "../../../../hooks/useOrganizationFavouriteLocations";
import OrganizationFavouriteLocationsList from "./OrganizationFavouriteLocationsList/OrganizationFavouriteLocationsList";
import OrganizationFavouriteLocationCreateModal from "./OrganizationFavouriteLocationCreateModal/OrganizationFavouriteLocationCreateModal";
import OrganizationFavouriteLocationDeleteModal from "./OrganizationFavouriteLocationDeleteModal/OrganizationFavouriteLocationDeleteModal";

const OrganizationFavouriteLocationsTab = ({
  organizationId,
}: {
  organizationId?: string;
}) => {
  const [authDetails, setAuthDetails] = useRecoilState(userAuthState);

  const { data: organizationFavouriteLocationsData } =
    useOrganizationFavouriteLocations({
      accessToken: authDetails?.accessToken,
      organizationId,
    });

  const [
    selectedOrganizationFavouriteLocation,
    setSelectedOrganizationFavouriteLocation,
  ] = useState<any>(null);

  const [
    showOrganizationFavouriteLocationCreateModal,
    setShowOrganizationFavouriteLocationCreateModal,
  ] = useState(false);

  const [
    showOrganizationFavouriteLocationDeleteModal,
    setShowOrganizationFavouriteLocationDeleteModal,
  ] = useState(false);

  console.log(
    "organizationFavouriteLocations",
    organizationFavouriteLocationsData
  );

  useEffect(() => {
    const handleDataChange = () => {
      const isVehicleClassMappingPresentInData =
        organizationFavouriteLocationsData?.some(
          (additionalCharge: any) =>
            additionalCharge.id === selectedOrganizationFavouriteLocation?.id
        );

      if (!isVehicleClassMappingPresentInData) {
        // setShowVehicleClassMappingModal(false);
        setShowOrganizationFavouriteLocationDeleteModal(false);
        setSelectedOrganizationFavouriteLocation(null);
      } else {
        const organizationFavouriteLocationInData =
          organizationFavouriteLocationsData?.find(
            (organizationFavouriteLocation: any) =>
              organizationFavouriteLocation.id ===
              selectedOrganizationFavouriteLocation?.id
          );
        setSelectedOrganizationFavouriteLocation(
          organizationFavouriteLocationInData
        );
      }
    };

    if (
      organizationFavouriteLocationsData &&
      organizationFavouriteLocationsData?.length &&
      selectedOrganizationFavouriteLocation
    ) {
      handleDataChange();
    } else if (
      !organizationFavouriteLocationsData ||
      !organizationFavouriteLocationsData.length
    ) {
      setShowOrganizationFavouriteLocationDeleteModal(false);
      setSelectedOrganizationFavouriteLocation(null);
    }
  }, [
    organizationFavouriteLocationsData,
    selectedOrganizationFavouriteLocation,
  ]);

  return (
    <Grid
      sx={{ padding: 2, position: "relative" }}
      rowSpacing={2}
      container
      direction={"column"}
      justifyContent={"space-evenly"}
    >
      <Grid
        container
        item
        justifyContent={"space-between"}
        alignContent={"center"}
        alignItems={"center"}
      >
        <Grid container item spacing={1} xs={12}>
          {/* Heading */}
          <Grid item xs={12}>
            <Typography fontSize={21} fontWeight={500}>
              Favourite Locations
            </Typography>
          </Grid>

          {isCurrentAdminSuperAdmin(authDetails) && (
            <>
              {/* <AdditionalPickUpRequestChargeDeleteModal
                accessToken={authDetails?.accessToken}
                open={showAdditionalPickUpChargeDeleteModal}
                setOpen={setShowAdditionalPickUpChargeDeleteModal}
                organizationId={organizationId}
                selectedAdditionalPickUpRequestCharge={
                  selectedAdditionalPickUpRequestCharge
                }
                setSelectedAdditionalPickUpRequestCharge={
                  setSelectedAdditionalPickUpRequestCharge
                }
              /> */}
              {/* <VehicleClassMappingModal
                accessToken={authDetails?.accessToken}
                open={showVehicleClassMappingModal}
                editMode={Boolean(selectedVehicleClassMapping)}
                setOpen={setShowVehicleClassMappingModal}
                organizationId={organizationId}
                selectedVehicleClassMapping={selectedVehicleClassMapping}
                setSelectedVehicleClassMapping={setSelectedVehicleClassMapping}
              /> */}
              <OrganizationFavouriteLocationDeleteModal
                organizationId={organizationId}
                accessToken={authDetails?.accessToken}
                open={showOrganizationFavouriteLocationDeleteModal}
                setOpen={setShowOrganizationFavouriteLocationDeleteModal}
                selectedOrganizationFavouriteLocation={
                  selectedOrganizationFavouriteLocation
                }
                setSelectedOrganizationFavouriteLocation={
                  setSelectedOrganizationFavouriteLocation
                }
              />
              <OrganizationFavouriteLocationCreateModal
                accessToken={authDetails?.accessToken}
                organizationId={organizationId}
                open={showOrganizationFavouriteLocationCreateModal}
                setOpen={setShowOrganizationFavouriteLocationCreateModal}
              />
              <Grid container item justifyContent={"flex-end"}>
                <Grid item>
                  <Button
                    onClick={() => {
                      setShowOrganizationFavouriteLocationCreateModal(true);
                    }}
                    icon={<PriceChangeIcon sx={{ marginRight: 2 }} />}
                  >
                    Add new organization favourite location
                  </Button>
                </Grid>
              </Grid>
            </>
          )}
          <Grid item xs={12}>
            <OrganizationFavouriteLocationsList
              organizationFavouriteLocationsData={
                organizationFavouriteLocationsData
              }
              onItemDeleteClick={(organizationFavouriteLocation: any) => {
                setSelectedOrganizationFavouriteLocation(
                  organizationFavouriteLocation
                );
                setShowOrganizationFavouriteLocationDeleteModal(true);
              }}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default OrganizationFavouriteLocationsTab;
